import classnames from 'classnames';
import DOMPurify from 'dompurify';
import { useState } from 'react';
import Collapse from 'react-bootstrap/Collapse';
import { IconButton } from '../../atoms/buttons/iconButton/IconButton';
import { IconColor } from '../../atoms/icon/Icon';
import * as styles from './FaqItem.module.scss';

interface IFaqItemProps {
    answer: string | JSX.Element;
    isHtmlAnswer?: boolean;
    question: string;
}

export function FaqItem(props: IFaqItemProps) {
    const checkAnswer = () => {
        if (typeof props.answer === 'string') {
            if (props.isHtmlAnswer) {
                return <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.answer) }} />;
            } else {
                return <p>{props.answer}</p>;
            }
        } else {
            if (props.isHtmlAnswer) {
                throw new Error('This should not happen: props.isHtmlAnswer is true, but props.answer is JSX.Element');
            }

            return <>{props.answer}</>;
        }
    };

    const [open, setOpen] = useState(false);

    return (
        <div className={styles.faqItem}>
            {/* TODO: Handle the accessibility issues */}
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div
                className={styles.faqHeader}
                onClick={() => setOpen(!open)}
            >
                <h4>{props.question}</h4>
                <IconButton
                    buttonClassName="ml-3"
                    color={IconColor.gray}
                    icon="caret"
                    iconClassName={classnames(styles.icon, open ? styles['open'] : styles['closed'])}
                    onClick={() => setOpen(!open)}
                />
            </div>
            <Collapse
                in={open}
                role="region"
            >
                <div className={styles.faqBody}>
                    <div className={styles.faqBodyText}>{checkAnswer()}</div>
                </div>
            </Collapse>
        </div>
    );
}
